import { render, staticRenderFns } from "./OzWallListRow.vue?vue&type=template&id=47c7ee0e&"
import script from "./OzWallListRow.vue?vue&type=script&lang=ts&"
export * from "./OzWallListRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./OzWallListRow.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports